module.exports = {"name":"youboralib","type":"lib","tech":"js","author":"Jordi Aguilar","version":"6.1.14","built":"2018-03-21","repo":"https://bitbucket.org/npaw/lib-plugin-js.git"}


//////////////////
// WEBPACK FOOTER
// ./~/youboralib/manifest.json
// module id = 29
// module chunks = 0